module.exports = __webpack_public_path__ + "img/44t.b559eeda.jpg";